import React from "react";
import "./LegacyOfTaste.css";
import Heading from "../Heading";

const LEGACY_ITEMS = [
  {
    id: 1,
    icon: "/assets/flag.png",
    title: "Made In India",
    description: "Authentic spices, born in India",
  },
  {
    id: 2,
    icon: "/assets/heritage-spice.png",
    title: "Heritage Spice Blends",
    description: "Traditional recipes, perfected over time",
  },
  {
    id: 3,
    icon: "/assets/love-across.png",
    title: "Loved Across Generations",
    description: "Trusted flavors, time after time",
  },
  {
    id: 4,
    icon: "/assets/delicious-flavours.png",
    title: "Delicious Flavours",
    description: "Big on taste. Bold in aroma",
  },
];

const LegacyOfTaste = () => {
  return (
    <div className="legacy-of-taste">
      <div className="legacy-of-taste__container">
        <Heading title="Our Legacy of Taste" />
        <br />
        <br />
        <div className="legacy-of-taste__grid">
          {LEGACY_ITEMS.map((item) => (
            <div key={item.id} className="legacy-item">
              <div className="legacy-item__icon">
                <img
                  src={item.icon}
                  alt={item.title}
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
              <h3 className="legacy-item__title">{item.title}</h3>
              <p className="legacy-item__description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LegacyOfTaste;



// WEBPACK FOOTER //
// ./src/components/LegacyOfTaste/LegacyOfTaste.js